import { combineReducers } from "redux";
import messages from "pages/Mail/Messages/store/messageReducer";
import conversations from "pages/Mail/ReadMessage/store/conversationReducer";
import singleMessage from "pages/Mail/ReadMessage/store/singleMessageReducer";
import messageCalenderReducer from "pages/Mail/ReadMessage/store/messageCalendarReducer";

import folders from "pages/Folders/store/folderReducer";
import logs from "pages/Logs/store/logsReducer";
import quarantines from "pages/Quarantine/store/quarantinesReducer";
import singleQuarantine from "pages/Quarantine/store/singleQuarantineReducer";
import activeDevices from "pages/Settings/ActiveDevices/store/activeDevicesReducer";
import failedSessions from "pages/Settings/ActiveDevices/store/failedSessionsReducer";
import templates from "pages/Settings/Signs/store/templatesReducer";
import archives from "pages/Archive/store/archivesReducer";
import singleArchive from "pages/Archive/store/singleArchiveReducer";
import savedArchiveSearches from "pages/Archive/SavedSearches/store/savedSearchesReducer";
import headerInfo from "pages/Mail/ReadMessage/store/headerInfoReducer";

export default combineReducers({
  folders,
  messages,
  conversations,
  singleMessage,
  logs,
  quarantines,
  singleQuarantine,
  activeDevices,
  failedSessions,
  archives,
  templates,
  singleArchive,
  savedArchiveSearches,
  messageCalenderReducer,
  headerInfo
});
